import React, { useState } from 'react';
import './FilterTeam.scss';
import { getImgTeam } from '../utils/utils';


const FilterTeam = ({ equipos, onFilter }) => {
    const [selectedTeam, setSelectedTeam] = useState('');

    const handleSelect = (equipo) => {
        if(equipo == selectedTeam){
            setSelectedTeam('');
            onFilter('');
        } else {
            setSelectedTeam(equipo);
            onFilter(equipo);
        }
    };

    return (
        <div className='filter-container' aria-label="Filtro por equipos">
            {equipos.map((equipo) => (
                (equipo.lastyear == "2026") && 
                <button
                    key={"equipo-" + equipo.nombre}
                    type="button"
                    className={selectedTeam == equipo.nombre ? 'img-team-container-selected' : 'img-team-container'}
                    onClick={() => handleSelect(equipo.nombre)}
                    aria-pressed={selectedTeam == equipo.nombre}
                    title={equipo.nombre}
                >
                    <img src={equipo.escudoClub} alt={equipo.nombre} className="img-filter-team" />
                </button>
                
            ))}
        </div>
    );
};

export default FilterTeam;

/*
 <div className='filter-container'>
            <select value={selectedTeam} onChange={handleSelect}>
                <option value="">Equipos</option>
                {equipos.map((equipo) => (
                    <option key={equipo.nombre} value={equipo.nombre}>
                        {equipo.nombre}
                    </option>
                ))}
            </select>
        </div>
*/